import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames } from "../../utils/helpers";
import { Text } from "../text";
import { View } from "../view";
import { useIsomorphicLayoutEffect } from 'usehooks-ts';
import { CheckboxGroup, useCheckboxGroup } from './checkbox-group';
import { useFormControl } from "../form-control";
import { Icon } from "../icon";
import { useElementId } from "../../hooks/useElementId";
import { Checkmark, Subtract } from '@az/starc-ui-icons';
import { useRefs } from "../../hooks/useRefs";
import s from './Checkbox.module.css';
export const Checkbox = ({ label, value, onChange, className, attributes, id, inputAttributes, checked: checkedProp, disabled: disabledProp, defaultChecked: defaultCheckedProp, name: nameProp, indeterminate, }) => {
    var _a;
    const checkboxGroup = useCheckboxGroup();
    const formControl = useFormControl();
    const inputId = useElementId(id);
    const disabled = (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) || disabledProp || (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled);
    const rootClassName = classNames(s.root, disabled && s.disabled, className);
    const checked = checkboxGroup ? (_a = checkboxGroup.value) === null || _a === void 0 ? void 0 : _a.includes(value) : checkedProp;
    const name = checkboxGroup ? checkboxGroup.name : nameProp || (inputAttributes === null || inputAttributes === void 0 ? void 0 : inputAttributes.name);
    const defaultChecked = checkboxGroup ? undefined : defaultCheckedProp;
    const inputRef = React.useRef(null);
    const handleChange = (event) => {
        // Type guard
        if ('target' in event) {
            if (!event.target.name)
                return;
            if (onChange)
                onChange(event);
            if (inputAttributes === null || inputAttributes === void 0 ? void 0 : inputAttributes.onChange)
                inputAttributes.onChange(event);
            if (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.onChange)
                checkboxGroup.onChange(event);
            // if (checkboxGroup?.onValueChange) checkboxGroup.onValueChange(value);
        }
        else {
            // Handle when event is ()=>unknown
            event();
        }
    };
    const TagName = typeof label === 'string' ? Text : View;
    const color = disabled ? 'gray-500' : 'on-primary';
    useIsomorphicLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate || false;
        }
    }, [indeterminate]);
    const mergedRef = useRefs([inputAttributes === null || inputAttributes === void 0 ? void 0 : inputAttributes.ref, inputRef]);
    const CheckIcon = indeterminate ? Subtract : Checkmark;
    return (_jsxs(TagName, Object.assign({ as: "label", className: rootClassName, "data-testid": "st-checkbox" }, attributes, { children: [_jsxs("div", { className: s['checkmark-container'], children: [_jsx("input", Object.assign({ className: s.input, type: "checkbox", name: name, onChange: handleChange, checked: checked, disabled: disabled, id: inputId, value: value, defaultChecked: defaultChecked, ref: mergedRef }, inputAttributes)), _jsx("div", { className: s['checkmark-border'] }), _jsx("div", { className: s['checkmark-box'] }), !disabled || checked || defaultChecked ? (_jsx(Icon, { className: s.checkmark, svg: CheckIcon, color: color, title: "Checkbox" })) : null] }), _jsx("span", { className: s['label-text'], children: label })] })));
};
Checkbox.Group = CheckboxGroup;
